import Image from "next/image";

function OtpError({ errorMessage }) {
  return (
    <div
      className="w-full h-[3.125rem] mt-[1.875rem] rounded-[0.625rem] flex items-center justify-center"
      style={{ backgroundColor: "rgba(255, 66, 66,0.06)" }}
    >
      <div className="text-error-color text-center flex flex-row items-center space-x-[1rem]">
        <Image
          src="/assets/icons/wrong-otp-icon.svg"
          width={20}
          height={20}
          alt="wrong-otp-icon"
        />
        <p>{errorMessage}</p>
      </div>
    </div>
  );
}

export default OtpError;
